export function ListingAccuracyGuide() {
  return (
    <section className="border-y border-slate-200 bg-white mb-8" data-testid="listing-accuracy-guide">
      <div className="grid md:grid-cols-[1.15fr_1fr_1fr_1fr] gap-px bg-slate-200">
        <div className="bg-navy text-white p-5 sm:p-6">
          <p className="font-body text-[10px] uppercase tracking-widest font-bold text-white/75">A clearer directory</p>
          <h2 className="font-heading text-xl text-white font-semibold mt-2">Know what is verified.</h2>
          <p className="font-body text-sm text-white/75 leading-relaxed mt-2">Every listing separates source facts, review status, and illustrative images.</p>
        </div>
        <div className="bg-white p-5 sm:p-6" data-testid="accuracy-guide-category">
          <p className="font-body text-[10px] uppercase tracking-widest font-bold text-brand-red">Category</p>
          <p className="font-body text-sm text-gray-700 leading-relaxed mt-2">Narrow labels require explicit evidence. Unclear records stay Pending Review.</p>
        </div>
        <div className="bg-white p-5 sm:p-6" data-testid="accuracy-guide-description">
          <p className="font-body text-[10px] uppercase tracking-widest font-bold text-brand-red">Description</p>
          <p className="font-body text-sm text-gray-700 leading-relaxed mt-2">Facts come from owners, OpenStreetMap, or stored venue-source details.</p>
        </div>
        <div className="bg-white p-5 sm:p-6" data-testid="accuracy-guide-image">
          <p className="font-body text-[10px] uppercase tracking-widest font-bold text-brand-red">Image</p>
          <p className="font-body text-sm text-gray-700 leading-relaxed mt-2">Owner photos are labeled. Category images are clearly marked as illustrative.</p>
        </div>
      </div>
    </section>
  );
}